import {TSubStatus} from "../types/authType";

export function isSubscriptionActiveOrTrialing(subStatus: TSubStatus | null): boolean {
	return subStatus === TSubStatus.Active || subStatus === TSubStatus.Trialing;
}
